import { useState } from "react";
import {
	ReportsWrapper,
	ReportCardWrapper,
	ReportCard,
	ModalReportsControls,
} from "./styles";
import { Button, Form } from "react-bootstrap";
import { MdOutlineAssignment } from "react-icons/md";
import { Modal } from "../../../components/modal";
import { IReportFileFormat, IReportType } from "../../../models/IReport";
import { getReport } from "../../../services/manager/admin/reports.service";
import { toast } from "react-toastify";
import { generateFile, prepareDataForReport } from "../../../utils/reports";

export const Reports: React.FC = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedReport, setSelectedReport] = useState(-1);
	const [selectedFormat, setSelectedFormat] = useState(-1);

	const [isLoading, setIsLoading] = useState(false);

	/** Listagem dos relatórios disponíveis */
	const reports: IReportType[] = [
		{
			title: "Disciplinas por Projetos",
			description:
				"Modelo de relatório com disciplinas, unidades e seus objetos",
			id: "discipline_project",
			color: "#134735",
		},
		{
			title: "Disciplinas e códigos",
			description:
				"Modelo de relatório com disciplinas, códigos e parceiros.",
			id: "discipline_code",
			color: "#323A80",
		},
		{
			title: "Objetos incompletos",
			description:
				"Modelo de relatório com disciplinas, unidades e os objetos cuja catalogação está incompleta.",
			id: "incomplete_media",
			color: "#DD7B2A",
		},
		{
			title: "Materiais Utilizados",
			description: "Modelo de relatório com materiais utilizados por clientes.",
			id: "user_discipline",
			color: "#C75136",
		},
		{
			title: "Relatório por Objetos",
			description:
				"Modelo de relatório com materiais utilizados por clientes.",
			id: "medias_report",
			color: "#173E47",
		},
	];

	/** Listagem dos formatos disponíveis */
	const fileFormats: IReportFileFormat[] = [
		{
			id: 0,
			format: "csv",
		},
		{
			id: 1,
			format: "xml",
		},
		{
			id: 2,
			format: "xlsx",
		},
	];

	const handleReportClick = (id: number) => {
		setSelectedReport(id);
		setModalOpen(true);
	};

	/** Método executado após a confirmação no modal */
	const handleConfirmReportRequest = () => {
		if (selectedFormat < 0) {
			toast.warn(
				`Selecione um formato de arquivo para gerar o relatório.`
			);
		} else {
			const reportType = reports[selectedReport].id;
			const format = fileFormats[selectedFormat].format;

			setIsLoading(true);

			getReport(reportType)
				.then((data) => {
					const treatedInput = prepareDataForReport(data, reportType);

					generateFile(
						format,
						treatedInput,
						`Relatório de ${reports[selectedReport].title}`
					);
				})
				.finally(() => {
					setIsLoading(false);
					setModalOpen(false);

					setSelectedFormat(-1);
					setSelectedReport(-1);
				});
		}
	};

	return (
		<ReportsWrapper>
			<h2>Relatórios</h2>

			{/* Tipos de relatórios disponíveis */}
			<ReportCardWrapper>
				{reports.map((report, index) => (
					<ReportCard key={report.id} background={report.color}>
						<Button onClick={() => handleReportClick(index)}>
							<MdOutlineAssignment></MdOutlineAssignment>
							<span>{report.title}</span>
						</Button>
						<span>{report.description}</span>
					</ReportCard>
				))}
			</ReportCardWrapper>

			{/* Modal para gerar o relatório */}
			<Modal
				variant="confirm-modal-default"
				loading={isLoading}
				fullSizeLoader
				hideControlsOnLoading
				loadingText={`Gerando relatório de ${reports[selectedReport]?.title}`}
				show={modalOpen}
				onHide={() => setModalOpen(false)}
				onSubmit={handleConfirmReportRequest}
				hasDefaultIcon={false}
				headerTitle={`Relatório - ${reports[selectedReport]?.title}`}
				submitButtonText="Exportar"
			>
				<p className="d-flex mb-4 mt-2">Formato</p>
				<ModalReportsControls>
					{fileFormats.map((format) => (
						// group
						<div key={`input-group-${format.id}`}>
							{/* check */}
							<Form.Check
								id={`format-${format.format}`}
								onChange={() =>
									selectedFormat === format.id
										? setSelectedFormat(-1)
										: setSelectedFormat(format.id)
								}
								checked={selectedFormat === format.id}
							></Form.Check>
							{/* label */}
							<Form.Label htmlFor={`format-${format.format}`}>
								{format.format}
							</Form.Label>
						</div>
					))}
				</ModalReportsControls>
			</Modal>
		</ReportsWrapper>
	);
};
